import { createServerFn } from "@tanstack/react-start";
import Stripe from "stripe";
import { z } from "zod";
import { SITE_URL } from "@/lib/seo";


const PRICES = {
  wdrozenie: { id: "price_1TXOqp0Gf6ZK7y3Onpa7ZhkT", mode: "payment" as const, label: "Wdrożenie" },
  wsparcie: { id: "price_1TXOsR0Gf6ZK7y3OOsDV8mpE", mode: "subscription" as const, label: "Wsparcie miesięczne" },
};

export const createCheckoutSession = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) =>
    z.object({ pkg: z.enum(["wdrozenie", "wsparcie"]) }).parse(input),
  )
  .handler(async ({ data }) => {
    const key = process.env.STRIPE_SECRET_KEY;
    if (!key) throw new Error("STRIPE_SECRET_KEY missing");

    const stripe = new Stripe(key);
    const { id: price, mode, label } = PRICES[data.pkg];

    const session = await stripe.checkout.sessions.create({
      mode,
      line_items: [{ price, quantity: 1 }],
      success_url: `${SITE_URL}/platnosc-sukces?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${SITE_URL}/cennik`,
      allow_promotion_codes: true,
      billing_address_collection: "auto",
      locale: "pl",
      metadata: { package: data.pkg, package_label: label },
      ...(mode === "subscription"
        ? { subscription_data: { metadata: { package: data.pkg, package_label: label } } }
        : { payment_intent_data: { metadata: { package: data.pkg, package_label: label } } }),
    });

    return { url: session.url };
  });
